/**
 * Returns a value with Gaussian (normal) distribution.
 *
 * @param mean The mean value of the distribution.
 * @param deviation The deviation (spreading at half-height) of the distribution.
 * @returns {number}
 */
export function normalVariable(mean, deviation) {
    let x, y, r;
    do {
        x = Math.random() * 2 - 1;
        y = Math.random() * 2 - 1;
        r = x * x + y * y;
    } while (!r || r > 1);
    return mean + deviation * x * Math.sqrt(-2 * Math.log(r) / r);
}
